<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('name')">
              name
              <i
                :class="
                  currentSort === 'name'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('status')">
              Status
              <i
                :class="
                  currentSort === 'status'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.name }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.status ? 'color:green' : 'color:red'">
              {{ list.status ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <EditKategori
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    EditKategori: () =>
      import('@/views/MasterData/Edit/TiketVendor/Kategori.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: '',
        name: '',
        updatedAt: '',
        update_by: '',
        status: '',
        note: '',
      },
      data: [
        {
          id: 1,
          name: 'CAT - Category 1',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          status: 'Active',
          note: 'Test 1',
        },
        {
          id: 2,
          name: 'GIL - GA,IT & lONG TAILS',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          status: 'Active',
          note: 'Test 2',
        },
        {
          id: 3,
          name: 'FEL - FUEL, LUBRICANT & ENERGY',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          status: 'Active',
          note: 'Test 3',
        },
        {
          id: 4,
          name: 'CPI - COAL PRoCESSING & INFRAStRUcTURE PROJECT',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          status: 'Active',
          note: 'Test 4',
        },
        {
          id: 5,
          name: 'MRR - MAINTENANCE & REPAIR, RENTAL',
          updatedAt: '28/12/2021 07:21',
          update_by: 'System',
          status: 'Active',
          note: 'Test 5',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        name: data.name,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        status: data.status,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    kategoriData() {
      const result = this.$store.state.mdDatabaseStore.kategoriData
      return result
    },
    sortedData() {
      return this.kategoriData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
